import {createRouter, createWebHistory} from 'vue-router'
import {useAuthStore} from "../store/auth";

const routes = [
    {
        path: "/rfi/:rfiId",
        name: "main-page",
        components: {
            default: () => import("../pages/RFIPage"),
            AppSidebar: () => import("../components/AppSidebar"),
            AppHeader: () => import("../components/AppHeader"),
        },
    },
    {
        path: "/create/:projectId",
        name: "create-rfi-page",
        components: {
            default: () => import("../pages/RFIPage"),
            AppSidebar: () => import("../components/AppSidebar"),
            AppHeader: () => import("../components/AppHeader"),
        },
    },
    {
        path: "/notes-templates",
        name: "notes-templates",
        components: {
            default: () => import("../pages/Notes"),
            AppHeader: () => import("../components/AppHeader"),
        },
    },
    {
        path: "/notes-classifications",
        name: "notes-classifications",
        components: {
            default: () => import("../pages/NotesClassifications"),
            AppHeader: () => import("../components/AppHeader"),
        },
    },
    {
        path: "/not-allowed/",
        name: "not-allowed",
        components: {
            default: () => import("../pages/NotAllowed"),
        },
    },
    {
        path: '/azurelogin/callback',
        name: 'page-login-auth-callback',
        component: () => import('../components/auth/AzureCallback'),
        meta: {
            skipAuth: true,
        },
    },
]

const router = createRouter({
    history: createWebHistory('/'),
    routes
})

router.beforeEach((to, from, next) => {
    const authStore = useAuthStore();

    // If auth required, check login. If login fails redirect to login page
    if (!to.meta.skipAuth) {
        if (!authStore.isUserLoggedIn) {
            if (typeof authStore.auth !== 'undefined' && authStore.auth.login_url.indexOf('http') !== -1) {
                localStorage.setItem('returnUrl', to.fullPath);
                window.location.href = authStore.auth.login_url;
                return;
            } else {
                router.push({
                    path: authStore.auth.login_url,
                    query: { to: to.path },
                });
            }
        }
        if (!authStore.isEmailConfirmed) {
            authStore.sendConfirmationCode();
        }
    }

    return next();
});

export default router
